import React, { useEffect } from 'react';
import Icon from '../Icon';
import { useDispatch } from 'react-redux';
import { addOverlay, removeOverlay } from '../../Actions/Overlay.action';
import PriceModal from '../../Types/PriceModal';

const PriceHistoryModal = ({
  content,
  close,
  open,
}: {
  content: PriceModal;
  close: () => void;
  open: boolean;
}) => {
  const { title, previouslyLowestPrice, description } = content;

  const dispatch = useDispatch();

  useEffect(() => {
    if (open) {
      dispatch(
        addOverlay('PriceHistoryModal', () => {
          close();
        })
      );
    }
  }, [open]);

  const onClick = () => {
    dispatch(removeOverlay('PriceHistoryModal'));
    close();
  };

  return (
    <div className="absolute left-1/2 top-1/2 z-50 flex w-full max-w-xs -translate-x-1/2 -translate-y-1/2 flex-col gap-2 rounded bg-white px-6 py-10 md:max-w-md">
      <button onClick={onClick} className="absolute right-2 top-2">
        <Icon name="close" className="h-6 w-6" />
      </button>
      <h5 className="uppercase">{title}</h5>
      <h4>{previouslyLowestPrice}</h4>
      <p className="text-lg">{description}</p>
    </div>
  );
};

export default PriceHistoryModal;
